import { isJsonString } from "vendor/application";

export const isPayloadValid = (intent, payload) => {
    return intent.extensions.body?.type !== "application/json" || isJsonString(payload);
  };